module.exports = __webpack_public_path__ + "static/media/31.f5692db8.mp3";